import { render } from "./BottomTabBarView.vue?vue&type=template&id=c862c9d4&scoped=true"
import script from "./BottomTabBarView.vue?vue&type=script&lang=js"
export * from "./BottomTabBarView.vue?vue&type=script&lang=js"

import "./BottomTabBarView.vue?vue&type=style&index=0&id=c862c9d4&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c862c9d4"]])

export default __exports__